import type { SxProps, Theme } from '@mui/material/styles';

export const addressStyles = {
	line: {
		textAlign: 'left'
	} satisfies SxProps<Theme>,

	intlSuffix: {
		color: 'text.secondary',
		ml: 0.5
	} satisfies SxProps<Theme>
};
